import React, { useContext, useState, useEffect, useRef } from 'react'
import { Col, Input, Form, } from 'antd'
import LogoIcon from '../../../../src/assets/images/logo_icon.png'
import TextArea from 'antd/es/input/TextArea'
import ImageCropper from '../ImageCropper/ImageCropper'
import { MultiStepFormData } from '../../Authentication/MultiStepForm/MultiStepForm'
import { useDispatch, useSelector } from 'react-redux'
import { businessInfo } from '../../../slices/businessInfo/thunk'
import { formatInputValue } from '../../../Services/InputFieldService'
import { PlaceholderContent } from '../../../constants/Placeholder'

const BusinessDescription = () => {
  let placeholderContent = PlaceholderContent?.SIGNUP_STEPS;
  const dispatch = useDispatch();
  const description = useRef(null)
  const [imageCropperError, setImageCropperError] = useState();
  const [formVerification, setFormVerification] = useState([false, false]);
  const info = useSelector((state) => state.BusinessInfoReducer);
  const [visible, setvisible] = useState(true);
  const [logoUrl, setLogoUrl] = useState('');
  const [descriptionDataLength, setDescriptionDataLength] = useState(0);
  const [descriptionError, setDescriptionError] = useState('');
  const [prefilledData, setPrefilledData] = useState({
    'business_description': '',
    'business_logo': ''
  })
  const [form] = Form.useForm();


  // Add state for error message

  let maxDataLength = 500;
  const data = (value, logosrc) => {
    setvisible(value);
    let logoImg = JSON.stringify(logosrc);
    setLogoUrl(logosrc);
  }
  const [active, setActive] = useState(false);
  const FormData = useContext(MultiStepFormData);

  const highLightingLength = (dataLength) => {
    setDescriptionDataLength(dataLength);

    if (dataLength <= maxDataLength) {
      if (dataLength === maxDataLength) {
        setActive(true)
      }
      else {
        setActive(false)
      }
      setDescriptionError('');
      setFormVerification([true, formVerification[0]]);
    }
    else {
      setDescriptionError(`Description cannot exceed ${maxDataLength} characters.`);

    }
  }
  const onChange = (e) => {
    const value = formatInputValue(e.target.value);
    highLightingLength(value?.length)
    FormData.setFormData({
      ...FormData.formData,
      businessDescription: value
    });

  };


  useEffect(() => {
    if (FormData.formData.logoUrl?.length) {
      setvisible(false)
    }

  }, [FormData.formData.logoUrl])

  useEffect(() => {
    setPrefilledData(prev => ({
      ...prev,
      business_description: info?.businessInfo?.old_business_description ? info?.businessInfo?.old_business_description : info?.businessInfo?.business_description || '',
      business_logo: info?.businessInfo?.old_business_logo?.original ? info?.businessInfo?.old_business_logo?.original : info?.businessInfo?.business_logo?.original|| ''
    }));

    if (info?.businessInfo?.business_description || info?.businessInfo?.old_business_description) {
      FormData.setFormData({
        ...FormData.formData,
        businessDescription: info?.businessInfo?.old_business_description ? info?.businessInfo?.old_business_description : info?.businessInfo?.business_description
      });
      FormData.setSkipButtonVisible(false)
    }

    setDescriptionDataLength(description.current?.resizableTextArea?.textArea?.value?.length)

  }, [info])

  useEffect(() => {
    // if (prefilledData.business_description) {
    //   FormData.setFormData({
    //     ...FormData.formData,
    //     businessDescription: info?.businessInfo?.business_description
    //   });
    // }
    if (prefilledData.business_logo) {
      FormData.setFormData({
        ...FormData.formData,
        logoUrl: prefilledData.business_logo
      });
      FormData.setSkipButtonVisible(false)
    }
  }, [prefilledData])
  const cropperError = (errorMessage) => {
    setImageCropperError(errorMessage)
  }

  useEffect(() => {
    const descriptionLength = FormData.formData.businessDescription?.length <= maxDataLength && FormData.formData.businessDescription.length;
    const logoPresent = FormData.formData.logoUrl?.length > 0 || prefilledData.business_logo;;

    if (descriptionLength > 5 || logoPresent) {
      FormData.setFormVerified({
        ...FormData.formVerified,
        [FormData.page]: true
      });
      
    } else {
      FormData.setFormVerified({
        ...FormData.formVerified,
        [FormData.page]: false
      });
    }
    console.log('logoPresent' , logoPresent)
  }, [FormData.formData.businessDescription, FormData.formData.logoUrl]);

  useEffect(() => {
    if (logoUrl) {
      FormData.setFormData({
        ...FormData.formData,
        logoUrl: logoUrl
      });
    }
  }, [logoUrl])

  useEffect(() => {
    dispatch(businessInfo())
  }, [dispatch])

  useEffect(() => {
    form.resetFields(); 
  }, [form]);

  useEffect(() => {
    const values = FormData?.formData?.businessDescription?.length;
    highLightingLength(values);
  }, [FormData?.formData])

useEffect(()=>{
  console.log('prefilledData' , prefilledData)
},[prefilledData])

  return (
    <div className='business_description'>
      <Form
        form={form}
        className='form_body business_description'>
        <div className='flex_body' style={{ position: 'relative', maxWidth: "704px", marginLeft: "auto", marginRight: "auto" }}>
          <Col xs={6} lg={6} className='business_logo' >
            <div style={{ display: "flex", height: "100%", alignItems: "center", flexDirection: "column" }}>
              <label className='text_red sm'>
                Business Logo
              </label>
              <div className="sm_icon logo_upload text-center" style={{ margin: "10px 0 0 0 " }}>
                {
                  (visible && !prefilledData.business_logo) && (
                    <>
                      <div className="logo_cnt">
                        <span style={{ display: "block", marginBottom: "10px", width: "37px", height: "37px" }}>
                          <img style={{ width: "100%", height: "100%", objectFit: "cover" }} src={LogoIcon} alt="" />
                        </span>
                        <div className="note">
                          <span style={{ fontSize: "11px", lineHeight: '1.5', display: "block" }}>
                            File Size: Max 5 MB
                          </span>
                        </div>
                      </div>
                    </>
                  )
                }
                {
                  (prefilledData.business_logo && !FormData.formData.logoUrl) && (
                    (
                      <span style={{ display: prefilledData.business_logo ? 'block' : 'none', width: '100%', height: '100%' }}>
                        <img
                          style={{ width: "100%", height: "100%", objectFit: "cover" }}
                          src={prefilledData.business_logo}
                          alt="Logo Icon"
                        />
                      </span>
                    )
                  )
                }

                <ImageCropper parent="multiStepForm" dataHandle={data} type="multiStepForm" duplicateImageUrl={FormData.formData.logoUrl} imageCropperError={cropperError} defaultHoverIcon={'change'} />
              </div>
            </div>
          </Col>
          <Col xs={24} lg={18} >
            <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
              <label className='text_red sm label_mob_center' style={{ paddingLeft: "36px", }}>
                Business Description
              </label>
              <Form.Item
                style={{ marginBottom: 0 }}
                validateStatus={descriptionError ? 'error' : ''}
                rules={[
                  {
                    required: true,
                    message: "Please enter you Description"
                  }
                ]}>
                <TextArea maxLength={500} ref={description} allowClear={false} className="input_field no-resize text_transform_normal" onChange={onChange} style={{ margin: "10px 0" }} value={FormData?.formData.businessDescription} placeholder={placeholderContent?.BusinessDescription}/>
              </Form.Item>
              <span className={` form_note ${active ? 'active' : ''}`} style={{ fontSize: "12px" }}><span>{descriptionDataLength}</span>/500</span>
            </div>
          </Col>
          <span className="logo_error">
            {imageCropperError}
          </span>
        </div>

      </Form>

    </div>
  )
}

export default BusinessDescription
